import { render, staticRenderFns } from "./TagFourPage.vue?vue&type=template&id=5897afa4&scoped=true&"
import script from "./TagFourPage.vue?vue&type=script&lang=js&"
export * from "./TagFourPage.vue?vue&type=script&lang=js&"
import style0 from "./TagFourPage.vue?vue&type=style&index=0&id=5897afa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5897afa4",
  null
  
)

export default component.exports